export const paginationOffset = (metadata) => {
  return metadata && metadata.currentPage && metadata.pageSize
    ? metadata.currentPage * metadata.pageSize
    : 0;
};
